const $ = require('jquery');

$(function(){
    const ratingContainer = $('.rating-container');

    if(ratingContainer.length === 0) {
        return;
    }

    const ratingStars = $('.rating-container .rating-star');
    const ratingInput = $('.rating-container input');

    ratingStars.on('mouseover', function() {
        const value = this.getAttribute('rate');
        animateRating(value);
    });

    ratingStars.on('mouseleave', function() {
        const value = ratingInput.val();
        animateRating(value);
    });

    ratingStars.on('click', function() {
        const value = this.getAttribute('rate');
        setRating(value);
    });
});

function animateRating(value){
    const ratingStarsWrapper =  $('.rating-stars-wrapper');

    ratingStarsWrapper.children().each(function() {
        const elementRate = this.getAttribute('rate');
        if(elementRate <= value){
            this.classList.add('active');
        }
        else {
            this.classList.remove('active');
        }
    });
}

function setRating(value) {
    const ratingInput = $('.rating-container input');
    ratingInput.val(value).trigger('change');

}